const l = "loyaltyScanDisplay_jhYcx", a = "loyaltyScanDisplay__both_8JKwX", y = "loyaltyScanDisplay__disabled_kX0il", s = "qr_OCiEE", t = {
  loyaltyScanDisplay: l,
  loyaltyScanDisplay__both: a,
  loyaltyScanDisplay__disabled: y,
  qr: s
};
export {
  t as default,
  l as loyaltyScanDisplay,
  a as loyaltyScanDisplay__both,
  y as loyaltyScanDisplay__disabled,
  s as qr
};
//# sourceMappingURL=loyaltyScanDisplay.module.scss.js.map
